import {
  useBatchSignedMedia,
  useSignedMedia,
} from "@/lib/hooks/use-signed-media";
import type { AvatarData } from "@somethings-ui/core";
import {
  StackedAvatars as StackedAvatarsComponent,
  UserAvatar as UserAvatarComponent,
  type StackedAvatarsProps,
  type UserAvatarProps,
} from "@somethings-ui/web";

export type { AvatarData };

export function StackedAvatars({ avatars, ...props }: StackedAvatarsProps) {
  const imageUrls = avatars.map((avatar) => avatar.imageUrl);
  const signedUrls = useBatchSignedMedia(imageUrls);

  const avatarsWithSignedUrls: AvatarData[] = avatars.map((avatar, i) => ({
    ...avatar,
    imageUrl: signedUrls[i]?.url || avatar.imageUrl,
  }));

  return <StackedAvatarsComponent avatars={avatarsWithSignedUrls} {...props} />;
}

export function UserAvatar({ imageUrl, name, ...props }: UserAvatarProps) {
  const { url: signedUrl } = useSignedMedia(imageUrl);

  return (
    <UserAvatarComponent
      imageUrl={signedUrl || imageUrl}
      name={name}
      {...props}
    />
  );
}
